import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {SubCategory} from '../state-man/models/sub-category.model';
import {UiService} from './ui.service';
import {LoggerService} from './logger.service';

@Injectable({
    providedIn: 'root'
})
export class SubCategoryService {

    constructor(private apiService: ApiService, private uiService: UiService) {
    }

    // version: the one that came with the list already held, or '' for none.
    public async getAll (version: string) : Promise<{ version: string, rows: SubCategory[] | null } | null> {
        try {
            const ret = await this.apiService.getVersionedList('it/sub_category/', version);
            return ret && { version: ret.version, rows: ret.rows && SubCategory.buildMany(ret.rows) };
        } catch (error) {
            LoggerService.log(error + 'it/sub_category/');
            await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.');
            return null;
        }
    };

}
